<template>
	<div>
		<div>
			<div class="search-field">
                <SvgIcon icon="search" />
                <input type="text" v-model="filterBy" :placerholder="$t('select.search.placeholder')" />
            </div>
            <ul>
            	<li 
					v-for="row in list" v-on:click="select(row.id)" 
					v-if="!filterBy || row.name.toLowerCase().indexOf(filterBy.toLowerCase()) >= 0">
					<div class="content">
						<p>{{ row.name }}</p>
					</div>
					<div v-if="selected == row.id" class="selector">
						<div class="checkmark">
	                        <SvgIcon icon="checkmark" />
	                    </div>
					</div>
				</li>
            </ul>
			
		</div>
	</div>
</template>

<script>
	import SvgIcon from './Svg.vue';
	export default {
		props: [
			'list',
			'emit',
			'value'
		],
		data: () => ({
			filterBy: '',
			selected: false
		}),
		components: {
            SvgIcon
        },
		mounted() {
			if (this.value) {
				this.selected = this.value;
			}
		},
		methods: {
			select(id) {
				this.selected = id;
				this.$root.$emit(this.emit, id);
			}
		}
	}
</script>